import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-landrec-grid',
  templateUrl: './landrec-grid.component.html',
  styleUrls: ['./landrec-grid.component.css']
})
export class LandrecGridComponent implements OnInit {
title="Land Use Details";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/landprocurement/land-rec-details/landrec-grid/landrec-grid.component.ts